import { ISignin, LocalizationPath, UserType } from '@tokyojob/core'
import SigninUseCase from '@/modules/auth/usecases/signin.usecase'
import { LocalizationService, RedirectURLResolver } from '@tokyojob/frontend-core'
import Vue from 'vue'
import { IAlertModalProps, getLocalization } from '@tokyojob/frontend-components'

interface IData {
  /**
   * If error modal is displayed
   */
  alertModalDisplay: boolean
  /**
   * Props for text and css of alert modal
   */
  alertModalProps: IAlertModalProps
  /**
   * Text used in alert modal body
   */
  alertBodyText: string
}

export default Vue.extend({
  data(): IData {
    const localization = getLocalization(this.App)
    const loginErrorTitle = LocalizationService.t<string>(localization, LocalizationPath.LoginPageErrorTitle)
    const alertModalProps: IAlertModalProps = { padding: 'ph-40', header: loginErrorTitle }
    const alertBodyText = LocalizationService.t<string>(localization, LocalizationPath.LoginPageErrorDescription)
    return {
      alertModalDisplay: false,
      alertModalProps,
      alertBodyText
    }
  },
  methods: {
    closeAlertModal() {
      this.alertModalDisplay = false
    },
    async submit(props: ISignin) {
      const usecase = new SigninUseCase(this.App)
      const result = await usecase.execute(props)

      if (result != null) {
        let redirectUrl = RedirectURLResolver.resolve(this.App.state, '/agent')
        switch (result.userType) {
          case UserType.Agent:
            window.location.href = redirectUrl
            break
          case UserType.Admin:
            redirectUrl = RedirectURLResolver.resolve(this.App.state, '/admin')
            this.$router.push(redirectUrl)
            break
          default:
            const locale = this.App.localizationSelector.languageLocale
            await this.App.candidateFullProfileDomain?.fullFetchRequest(locale)
            redirectUrl = RedirectURLResolver.resolve(this.App.state, '/')
            this.$router.push(redirectUrl)
            break
        }
      } else {
        this.alertModalDisplay = true
      }
    }
  }
})
